import * as translation from "./fr-FR.json";

export const translationFrFR = translation.default;
